import styled from "styled-components";
import { device } from "../breakpoints";

export const HeroContentSection = styled.section`
  height: 70vh;
  @media ${device.mobile} {
    height: auto;
  }
`;
export const HeroContentWrapper = styled.div`
  display: flex;
  width: 1200px;
  margin: 0 auto;
  h2 {
    width: 566px;
    font-size: 48px;
    line-height: 56px;
    color: #000;
    font-weight: 400;
    font-family: "Raleway";
    span {
      color: #38a97a;
    }
    @media ${device.mobile} {
      width: 100%;
      font-size: 24px;
      line-height: 28px;
    }
  }
  @media ${device.mobile} {
    width: 100%;
    padding: 70px 16px;
  }
`;
